import { createAction } from 'redux-starter-kit';

export const putLegalDocument = createAction('PUT_LEGAL_DOCUMENT');

export const putLegalDocuments = createAction('PUT_LEGAL_DOCUMENTS');

export const deleteLegalDocument = createAction('DELETE_LEGAL_DOCUMENT');
